import React, { useState } from 'react';
import OccurrenceInputRow from "./OccurrenceInputRow";
import Fade from "@mui/material/Fade";
import { TransitionGroup } from "react-transition-group";
import { Collapse } from "@mui/material";
import OccurrencesMessage from "./OccurrencesMessage";
import LoadingSpinner from "../../../Gfx/LoadingSpinner";
import { useRecurrenceManagementForm } from "../RecurrenceManagementFormProvider";

const OccurrenceManagementInput = () => {
    const {
        bookingConfig,
        calculatedOccurrences,
        rescheduledOccurrences,
        onRescheduleChange,
        isLoading
    } = useRecurrenceManagementForm();

    let [showAvailableOccurrences, setShowAvailableOccurrences] = useState(false);

    const shouldShowThisOccurrence = (occurrence) => {
        if (showAvailableOccurrences) {
            return true;
        }

        if (occurrence.is_available === false) {
            return true;
        }

        return false;
    }

    if (isLoading) {
        return <LoadingSpinner/>
    }

    return (<>
        <OccurrencesMessage
            showAvailable={showAvailableOccurrences}
            onToggle={(value) => setShowAvailableOccurrences(value)}
        />

        <Fade in={calculatedOccurrences && calculatedOccurrences.length > 0}>
            <div>
                <TransitionGroup>
                    {Object
                        .keys(calculatedOccurrences)
                        .filter(key => shouldShowThisOccurrence(calculatedOccurrences[key]))
                        .map(key =>
                            <Collapse key={key}>
                                <OccurrenceInputRow
                                    bookingConfig={bookingConfig}
                                    occurrence={calculatedOccurrences[key] ?? null}
                                    rescheduledOccurrences={rescheduledOccurrences}
                                    onReschedule={onRescheduleChange}
                                />
                            </Collapse>
                        )
                    }
                </TransitionGroup>
            </div>
        </Fade>
    </>);
};

export default OccurrenceManagementInput;
